import webicon from "./logo@2x.png";
import webbg from "./BAck@2x.png";
import movilicon from "./Logo bc@2x.png";
import movilbg from "./BAckmovil@2x.png";
import bannerimg from "./pantallas@2x.png";
import ctaimg from "./Desarrollamos@2x.png";
import serviceapp from "./gifs/app.gif";
import serviceweb from "./gifs/web.gif";
import serviceecommerce from "./gifs/ecomerce.gif";
import serviceemail from "./gifs/email.gif";
import serviceredes from "./gifs/redes_sociales.gif";
import servicegoogleads from "./gifs/googleadds.gif";
import c1 from "./udlap@2x.png";
import c2 from "./logo_evolucione@2x.png";
import c3 from "./lachoza@2x.png";
import c4 from "./logo_canacintra@2x.png";
import c5 from "./tecmilenio@2x.png";
import c6 from "./logo-img@2x.png";
import c7 from "./tecmilenio-1@2x.png";
import c8 from "./arteplastic@2x.png";
import clientsbg from "./back forma@2x.png";
import os1 from "./SEO@2x.png";
import os2 from "./branding@2x.jpg";
import os3 from "./INBOUND@2x.png";
import os4 from "./ecomerce@2x.png";
import os1icon from "./SEO icon@2x.png";
import os2icon from "./Branding ICOn@2x.png";
import os3icon from "./Inbound Icon@2x.png";
import os4icon from "./Comercio Icon@2x.png";
import p1 from "./Google Analytics@2x.png";
import p2 from "./Google Adwords@2x.png";
import p3 from "./Google Partner@2x.png";
import footerimg from "./logo_pie@2x.png";
import footertel from "./Telefono@2x.png";
import footermail from "./mail_pie@2x.png";
import footerdir from "./direccion@2x.png";
import footerfac from "./facebook_pie-1@2x.png";
import footertwi from "./twitter pie-1@2x.png";
import footerinst from "./Instagram pie-1@2x.png";

const imgs = {
  intro: {
    icon: {
      movilsrc: movilicon,
      websrc: webicon,
      alt: "Marketing digital"
    },
    bg: {
      movilsrc: movilbg,
      websrc: webbg,
      alt: "Marketing digital"
    }
  },
  banner:{
    img:{
      src: bannerimg,
      alt: "Diseño y desarrollo de páginas web"
    }
  },
  cta:{
    img:{
      src: ctaimg,
      alt:"Diseño y desarrollo de páginas web"
    }
  },
  services:{
    app:{
      src:  serviceapp,
      alt: "Diseño y desarrollo de páginas web"
    },
    web:{
      src: serviceweb,
      alt: "Diseño y desarrollo de páginas web"
    },
    ecommerce:{
      src: serviceecommerce,
      alt: "Diseño y desarrollo de páginas web"
    },
    email:{
      src: serviceemail,
      alt: "Diseño y desarrollo de páginas web"
    },
    redes:{
      src: serviceredes,
      alt: "Diseño y desarrollo de páginas web"
    },
    googleads:{
      src: servicegoogleads,
      alt: "Diseño y desarrollo de páginas web"
    }
  },
  clients:{
    bg:{
      src: clientsbg,
      alt: "Estrategias de marketing digital"      
    },
    c1:{
      src:c1,
      alt: "Estrategias de marketing digital"
    },
    c2:{
      src:c2,
      alt: "Estrategias de marketing digital"
    },
    c3:{
      src:c3,
      alt: "Estrategias de marketing digital"
    },
    c4:{
      src:c4,
      alt: "Estrategias de marketing digital"
    },
    c5:{
      src:c5,
      alt: "Estrategias de marketing digital"
    },
    c6:{
      src:c6,
      alt: "Estrategias de marketing digital"
    },
    c7:{
      src:c7,
      alt: "Estrategias de marketing digital"
    },
    c8:{
      src:c8,
      alt: "Estrategias de marketing digital"
    }
  },
  otros:{
    os1:{
      icon: os1icon,
      src: os1,
      alt: "Estrategias de marketing digital"
    },
    os2:{
      icon: os2icon,
      src: os2,
      alt: "Estrategias de marketing digital"
    },
    os3:{
      icon: os3icon,
      src: os3,
      alt: "Estrategias de marketing digital"
    },
    os4:{
      icon: os4icon,
      src: os4,
      alt: "Estrategias de marketing digital"
    }
  },
  partners:{
    p1:{
      src: p1,
      alt: "Estrategias de marketing digital"
    },
    p2:{
      src: p2,
      alt: "Estrategias de marketing digital"
    },
    p3:{
      src: p3,
      alt: "Estrategias de marketing digital"
    }
  },
  footer:{
    img: footerimg,
    tel: footertel,
    mail: footermail,
    dir: footerdir,
    fac: footerfac,
    twi: footertwi,
    inst: footerinst,
    alt:"Estrategias de marketing digital"
  }
};

export default imgs;



// WEBPACK FOOTER //
// ./src/imgs/img_elements.js